import RESTAdapter from '@ember-data/adapter/rest';
import { jsonGet, jsonPost } from '@square/dashboard-utilities/utils/xhr';
import { connectHost } from '@square/environment-utils/connect-urls';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { hash } from 'rsvp';
import { v4 as uuid } from 'uuid';
const RESOURCE_URL = `//${connectHost(location.host)}/v2/credit-packs`;
const DEFAULT_OPTIONS = {
  headers: {
    'X-CSRF-Token': getCsrfToken()
  }
};

// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.ListCreditActivitiesResponse

// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.CreateCreditActivityResponse

// https://prototype.sqprod.co/#/docs/squareup.credittracking.service.RetrieveCreditActivityResponse

export default class CreditActivity extends RESTAdapter {
  // https://prototype.sqprod.co/#/docs/squareup.credittracking.service.ListCreditActivitiesRequest
  query(_store, _type, filter) {
    const {
      id,
      cursor,
      limit
    } = filter;
    let url = `${RESOURCE_URL}/${id}/activities`;
    if (cursor || limit) {
      const params = {
        cursor,
        limit
      };
      url = `${url}?${new URLSearchParams(params.toString())}`;
    }
    const data = jsonGet(url, DEFAULT_OPTIONS);

    // Create and return hash to satisfy RESTAdapter TS definitions
    return hash({
      data
    }).then(response => response.data);
  }

  // https://prototype.sqprod.co/#/docs/squareup.credittracking.service.CreateCreditActivityRequest
  createRecord(_store, _type, snapshot) {
    const {
      credit_pack_id,
      ...requestData
    } = this.serialize(snapshot, {});
    const url = `${RESOURCE_URL}/${credit_pack_id}/activities`;

    // Remove null values from request data
    Object.keys(requestData).forEach(key => requestData[key] === null && delete requestData[key]);
    const responseData = jsonPost(url, {
      idempotency_key: uuid(),
      activity: requestData
    }, DEFAULT_OPTIONS);
    return hash({
      data: responseData
    }).then(response => response.data);
  }

  // https://prototype.sqprod.co/#/docs/squareup.credittracking.service.RetrieveCreditActivityRequest
  findRecord(_store, _type, id) {
    const url = `//${connectHost(location.host)}/v2/credit-pack-activities/${id}`;
    const data = jsonGet(url, DEFAULT_OPTIONS);
    return hash({
      data
    }).then(response => response.data.activity);
  }
}